export default __webpack_public_path__ + "static/media/coding.abbea761.gif";